export default __webpack_public_path__ + "static/media/collab1.5bc93197.png";